exports.refreshStickyWrapperHeight = () => {
    $(".sticky-element").each(function (i, e) {
        const $stickyWrapper = $(e).parent();
        if ($(e).length && $stickyWrapper.length) {
            $stickyWrapper.css({"min-height" : $(e).outerHeight(true)});
        }
    });
};
